// src/features/wallet/services/walletService.ts
import apiService from '@core/api/apiService';

export interface WalletInfo {
  id: string;
  balance: number;
  total_debit: number;
  total_credit: number;
}

export interface WalletTransaction {
  id: string;
  wallet_id: string;
  type: 'debit' | 'credit' | 'credit_note' | 'settlement' | 'refund' | 'debt_reversal';
  amount: number;
  remaining_amount?: number;
  description: string;
  reference_type: string;
  reference_id?: string;
  document_number?: string;
  status: 'pending' | 'approved' | 'rejected' | 'refunded';
  settled_at?: string;
  approved_by?: string;
  approved_at?: string;
  created_at: string;
  wallet?: {
    user?: {
      name: string;
      lastname: string;
      mobile_number: string;
    };
  };
}

export interface WalletResponse {
  wallet: WalletInfo;
  transactions: {
    data: WalletTransaction[];
    total: number;
    current_page: number;
    per_page: number;
  };
}

export const walletService = {
  // دریافت اطلاعات کیف پول
  getWallet: (page = 1): Promise<WalletResponse> =>
    apiService.get<WalletResponse>('/v1/user/wallet', { page }),

  // شارژ کیف پول
  getChargeBankAccounts: (): Promise<{ bank_accounts: Array<{ id: string; label: string; account_number?: string; sheba?: string }> }> =>
    apiService.get('/v1/user/wallet/bank-accounts'),

  chargeWallet: (amount: number, receipt: File, bankAccountId: string, description?: string): Promise<{ transaction: WalletTransaction; message: string }> => {
    const formData = new FormData();
    formData.append('amount', String(amount));
    formData.append('receipt', receipt);
    formData.append('bank_account_id', bankAccountId);
    if (description) formData.append('description', description);
    return apiService.post('/v1/user/wallet/charge', formData);
  },

  // دریافت تسویه‌های در صف بررسی
  getPendingSettlements: (params?: { page?: number; per_page?: number }): Promise<{
    transactions: {
      data: WalletTransaction[];
      total: number;
      current_page: number;
      per_page: number;
    };
  }> => apiService.get('/v1/user/wallet/pending-settlements', params || {}),

  // تایید تسویه
  approveSettlement: (id: string): Promise<any> =>
    apiService.post(`/v1/user/wallet/settlements/${id}/approve`),

  // رد تسویه
  rejectSettlement: (id: string): Promise<any> =>
    apiService.post(`/v1/user/wallet/settlements/${id}/reject`),

  // لیست بدهی صادرکنندگان
  getIssuerDebts: (params?: { page?: number; per_page?: number; search?: string; only_debtors?: boolean; sort_by?: 'total_debit' | 'total_credit' | 'balance'; sort_order?: 'asc' | 'desc' }): Promise<{
    users: {
      data: Array<{
        id: string;
        name: string;
        lastname: string;
        mobile_number: string;
        role_titles: string[];
        wallet: {
          id: string | null;
          total_debit: number;
          total_credit: number;
          balance: number;
        };
      }>;
      total: number;
      current_page: number;
      per_page: number;
      last_page: number;
    };
  }> =>
    apiService.get('/v1/user/wallet/issuer-debts', params),

  // جزئیات کیف پول کاربر
  getUserWallet: (userId: string): Promise<{
    user: {
      id: string;
      name: string;
      lastname: string;
      mobile_number: string;
    };
    wallet: {
      id: string | null;
      total_debit: number;
      total_credit: number;
      balance: number;
    };
    transactions: {
      data: WalletTransaction[];
      total: number;
      current_page: number;
      per_page: number;
    };
  }> =>
    apiService.get(`/v1/user/wallet/user/${userId}`),
};

export default walletService;
